import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0886b176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sheet-music-sing" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "question-title" }
const _hoisted_4 = {
  key: 0,
  class: "title-index"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "question-score"
}
const _hoisted_7 = { class: "sheet-music-sing-no-sheetfile" }
const _hoisted_8 = { class: "sheetMusicSingMask" }
const _hoisted_9 = { class: "sheetMusicSingText" }

import useCompileContent from "@/hooks/useCompileContent";
import useExam from "@/hooks/useExam";
import useMusicScore from "@/hooks/useMusicScore";
import useUpLoadResource from "@/hooks/useUpLoadResource";
import { platform } from "@/services/platform";
import { unLock } from "@/utils/liner-lock";
import SheetMusicSing from "@evideo/design-vue/lib/sheet-music-sing";
import "@evideo/design-vue/lib/sheet-music-sing/style";
import _ from "lodash";
import {
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { onBeforeRouteLeave } from "vue-router";
import ConfirmDialog from "./ConfirmDialog.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
  uploadProctor: {
    type: Boolean,
    default: false,
  },
  mp3WorkerPathPrefix: {
    type: String,
  },
},
  emits: ["error"],
  setup(__props, { expose, emit: emits }) {

const props = __props



// 是否展示题号
const { appContext } = getCurrentInstance()!;
const { singInterfaces } = useMusicScore();
const { upload, md5 } = useUpLoadResource();
const { showExamMessageBox } = useExam();
const { compileQuestionTitle } = useCompileContent();

const question = ref(props.question || {});
watch(
  () => props.question,
  (now: any) => {
    question.value = now;
  },
  { deep: true }
);

const sheetMusicSingEl = ref<HTMLDivElement>();
const childSheetMusic = ref<any>(null);
const answerScore = ref(undefined);
const answerAudio = ref();
const answerAudioPath = ref("");
const answerAudioMd5 = ref("");

const loading = ref(true);
const confirmTitle = ref("");
const confirmContent = ref("");
let musicSingLoading = ref(false);
const musicSingLoadingText = ref("曲谱题目加载中...");
let data = {
  song: {},
  midiTestRecordScore: true,
  style: {
    top: "auto",
    left: "2vw",
    bottom: "4vh",
    position: "fixed",
  },
  recordScoreOptions: {
    inputChannel: 1,
    sampleRate: 16000,
    options: {
      srcSampleRate: 16000,
      mp3BitRate: 64,
    },
    mp3WorkerPathPrefix: props.mp3WorkerPathPrefix || "",
  },
  loadSheetMode: "common",
  svgApi: `${process.env.VUE_APP_PRE_RENDER_SERVICE}/sheet-svg/render-data`,
};

const sheetFileLoaded = ref(false);
const hasSheetFile = ref(false);
const musicScore = ref<any>();

const questionTitle = ref<HTMLDivElement>();
compileQuestionTitle(questionTitle, question.value.title || "");

const handleCancelSubmitExam = () => {
  console.log(childSheetMusic.value.destroyAllFlag);
  childSheetMusic.value.destroyAllFlag = false;
};

const getAnswer = async () => {
  console.log("get sheetMusicSing answer");
  await childSheetMusic.value.destroyAll(false);
  if (!sheetFileLoaded.value) {
    console.warn("当前视唱题曲谱加载失败，没有答案可上传");
    return;
  }
  if (props.disabled) {
    // 禁用了不用获取答案
    return { type: 0 };
  }
  if (question.value.answer_params && !answerAudio.value) {
    // 此题之前回答过，但此次未回答时
    const { record_file_url, aiScore, record_file_md5 } =
      question.value?.answer_params;
    const answerParams = {
      aiScore: aiScore,
      record_file_url,
      record_file_md5,
    };
    return { type: 0 };
  }
  const paperId = question.value.paper_id;
  const savePath = `${paperId}/${question.value!.id}`;

  if (answerAudio.value) {
    const uploadRes = await upload(
      new File(
        [answerAudio.value],
        `${paperId}_${question.value!.id}_answer.mp3`,
        {
          type: answerAudio.value.type,
          lastModified: Date.now(),
        }
      ),
      savePath,
      {},
      props.uploadProctor
    ).catch((err) => {
      console.warn("sheetsong", err);
      throw err;
    });
    console.log("----uploadRes----", uploadRes);
    answerAudioPath.value = uploadRes.url;
    answerAudioMd5.value = uploadRes.md5;
  }
  if (answerAudioPath.value && answerAudioMd5.value) {
    answerAudioMd5.value = await getRecordFileUrlMd5(answerAudioPath.value);
  }
  const params = {
    aiScore: answerScore.value,
    record_file_url: answerAudioPath.value,
    record_file_md5: answerAudioMd5.value,
  };
  if (!question.value.answer_params) {
    //* 没有回答过
    if (params.aiScore === undefined) {
      //* 直接跳下一题
      return { type: 0 };
    }
    return {
      type: 1,
      answer_params: params,
    };
  } else {
    //* 回答过
    if (originRecordFileUrlMd5.value === params.record_file_md5) {
      //* 直接跳下一题
      return { type: 0 };
    }
    return {
      type: 1,
      answer_params: params,
    };
  }
};

const originRecordFileUrlMd5 = ref("");
const getRecordFileUrlMd5 = async (record_file_url: string) => {
  const response = await fetch(record_file_url);
  const blob = await response.blob();
  return md5(new File([blob], `${question.value!.id}_answer.mp3`));
};

const dailogShow = ref(false);
const submitDisabled = ref(false);
const reSingState = ref(false);

const handleCancel = () => {
  dailogShow.value = false;
  reSingState.value = false;
};
const audioAgainLoading = ref(false);

const handleSubmit = _.throttle(() => {
  submitDisabled.value = true;
  dailogShow.value = false;
  if (reSingState.value) {
    reSingState.value = false;
    // await childSheetMusic.value.initRecorder();
    childSheetMusic.value.startRecordScore();
    childSheetMusic.value.replayVisible = false;
  } else {
    audioAgainLoading.value = true;
    musicSingLoadingText.value = "音频加载中...";
    childSheetMusic.value.initAudio();
  }
  setTimeout(() => {
    submitDisabled.value = false;
  }, 500);
}, 1000);

const handleReSingConfirm = () => {
  reSingState.value = true;
  confirmTitle.value = "重新演唱";
  confirmContent.value = "重新演唱将会覆盖之前的演唱记录，确定要重新演唱吗？";
  dailogShow.value = true;
};

const getRecord = (recordAudio: any, recordPath: any, score: any) => {
  console.log(recordAudio, recordPath, score);
  answerAudio.value = recordAudio;
  answerAudioPath.value = recordPath;
  answerScore.value = score;
};

let closeLoading: any = undefined;
const loadingDownloadFluidSynthJsTip = ref("");

const handleLoading = (status: boolean, loadingDownloadTip?: string) => {
  if (status) {
    loading.value = true;
    if (!closeLoading) {
      // 曲谱加载中且无实例
      musicSingLoading.value = true;
      musicSingLoadingText.value = "曲谱题目加载中...";
      // closeLoading = showLoading("曲谱题目加载中...", 0);
      closeLoading = true;
    }
    if (loadingDownloadTip) {
      loadingDownloadFluidSynthJsTip.value = loadingDownloadTip;
    }
  } else {
    musicSingLoading.value = false;
    loading.value = false;
    if (closeLoading) {
      // 曲谱加载完毕，关闭实例
      closeLoading = false;
      if (
        childSheetMusic.value.initSuccess &&
        !childSheetMusic.value.audioCanPlay &&
        !dailogShow.value
      ) {
        musicSingLoading.value = true;
        musicSingLoadingText.value = "音频加载中...";
      }
    }
    if (loadingDownloadFluidSynthJsTip.value) {
      loadingDownloadFluidSynthJsTip.value = "";
    }
  }
};
const loadSingQuestion = () => {
  try {
    const { sheet_file_url } = question.value?.question_params || {};
    const { record_file_url, aiScore } = question.value?.answer_params || {};
    data.song = {
      sheetFileUrl: sheet_file_url,
      recordFileUrl: record_file_url,
    };
  } catch (e) {
    console.warn("曲谱题目加载失败", e);
    showExamMessageBox({
      message: "题目加载失败，请稍后再次尝试",
    });
  }
};

const handleAudioCacheSuccess = () => {
  if (musicSingLoading.value) {
    musicSingLoading.value = false;
  }
  if (audioAgainLoading.value) {
    audioAgainLoading.value = false;
  }
};

const handleAudioCacheError = (error: any) => {
  if (musicSingLoading.value) {
    musicSingLoading.value = false;
  }
  if (audioAgainLoading.value) {
    audioAgainLoading.value = false;
  }
  confirmTitle.value = "音频加载失败";
  confirmContent.value = "音频加载失败，请重新加载！";
  dailogShow.value = true;
};

const showComponentError = (msg: any) => {
  // showExamMessageBox({
  //   message: msg,
  // });
  emits("error", msg);
};

const showResult = () => {
  // loadSingQuestion();
  const resultScore = document.createElement("div");
  resultScore.style.fontSize = "30px";
  resultScore.style.display = "flex";
  resultScore.style.justifyContent = "flex-start";
  resultScore.style.color = "#495561";
  resultScore.style.marginTop = "60px";
  resultScore.style.height = "20px";
  resultScore.innerHTML =
    "<div style='width:160px;margin-left: 10px;text-align:left;'>作答结果:</div>" +
    "<div style='width: calc(100% - 160px);text-align:left;'>" +
    (question.value?.answerScore || 0) +
    "分</div>";
  sheetMusicSingEl.value && sheetMusicSingEl.value.appendChild(resultScore);

  const resultAnalysis = document.createElement("div");
  const resultAnalysisContent = document.createElement("div");
  resultAnalysis.style.fontSize = "30px";
  resultAnalysis.style.display = "flex";
  resultAnalysis.style.justifyContent = "flex-start";
  resultAnalysis.style.color = "#495561";
  resultAnalysis.style.marginTop = "60px";

  resultAnalysis.innerHTML =
    "<div style='width:120px;margin-left:10px;text-align:left;margin-bottom:60px;'>解析:</div>";
  resultAnalysisContent.style.width = "calc(100% - 120px)";
  resultAnalysisContent.style.textAlign = "left";
  resultAnalysisContent.innerHTML = question.value?.analysis || "";

  resultAnalysis.appendChild(resultAnalysisContent);

  sheetMusicSingEl.value && sheetMusicSingEl.value.appendChild(resultAnalysis);
};

watch(
  () => loading.value,
  () => {
    if (props.disabled) {
      showResult();
    }
  }
);

watch(
  () => props.disabled,
  () => {
    if (props.disabled) {
      showResult();
    }
  }
);

onBeforeMount(async () => {
  const { record_file_url } = question.value?.answer_params || {};
  if (!record_file_url) {
    return;
  }
  originRecordFileUrlMd5.value = await getRecordFileUrlMd5(record_file_url);
});
// onActivated(async () => {
//   if (!hasSheetFile.value) {
//     return;
//   }
//   setTimeout(() => {
//     loadSingQuestion();
//   }, 500);
// });
const loadFluidsynthJsSoundFont = async () => {
  if (window.platform === "android") {
    return;
  }
  try {
    const data = await platform?.getFluidsynthJsSoundFont();
    return data;
  } catch (e) {
    console.error("音色库下载出错", e);
    return;
  }
};
onMounted(async () => {
  const { sheet_file_url } = question.value?.question_params || {};
  if (!sheet_file_url) {
    console.error("question no sheet_file_url");
    return;
  }
  hasSheetFile.value = true;
  sheetFileLoaded.value = true;
  loadSingQuestion();
  unLock();
});

expose({ getAnswer, handleCancelSubmitExam });
onBeforeRouteLeave(async (to: any) => {
  // 前往查看联系记录停止演唱
  if (to.name === "FreePracticeRecord") {
    await childSheetMusic.value.destroyAll();
  }
});
onBeforeUnmount(async () => {
  if (musicScore.value) {
    musicScore.value.hide();
  }
  await childSheetMusic.value.destroyAll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        ref_key: "sheetMusicSingEl",
        ref: sheetMusicSingEl,
        class: "sheet-music-sing-container"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (props.showQuestionNum)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(question.value.indexInQuestion !== undefined
                ? question.value.indexInQuestion + "."
                : "") + _toDisplayString(question.value.titleNum > 0 ? question.value.titleNum : ""), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              innerHTML: question.value.title,
              class: "title-content",
              ref_key: "questionTitle",
              ref: questionTitle
            }, null, 8, _hoisted_5)
          ]),
          (props.showQuestionScore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " (" + _toDisplayString(question.value.score) + "分) ", 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(SheetMusicSing), _mergeProps({
          ref_key: "childSheetMusic",
          ref: childSheetMusic
        }, _unref(data), {
          "sheet-music-sing-el": sheetMusicSingEl.value,
          disabled: props.disabled,
          midiTestRecordScore: false,
          loadFluidSynthJs: loadFluidsynthJsSoundFont,
          onOnReSingConfirm: handleReSingConfirm,
          onRecordSuccess: getRecord,
          onOnLoading: handleLoading,
          onAudioCacheError: handleAudioCacheError,
          onAudioCacheSuccess: handleAudioCacheSuccess,
          onOnError: showComponentError
        }), null, 16, ["sheet-music-sing-el", "disabled"])
      ], 512), [
        [_vShow, hasSheetFile.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, " 没有测评曲谱文件 ", 512), [
        [_vShow, !hasSheetFile.value]
      ]),
      _createVNode(ConfirmDialog, {
        header: confirmTitle.value,
        content: confirmContent.value,
        visible: dailogShow.value,
        submitDisabled: submitDisabled.value,
        onCancel: handleCancel,
        onSubmit: _unref(handleSubmit)
      }, null, 8, ["header", "content", "visible", "submitDisabled", "onSubmit"])
    ]),
    (
      _unref(musicSingLoading) || loadingDownloadFluidSynthJsTip.value || audioAgainLoading.value
    )
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(loadingDownloadFluidSynthJsTip.value
            ? loadingDownloadFluidSynthJsTip.value
            : musicSingLoadingText.value), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})